import useFormatNumbers from "customHooks/useFormatNumbers";
import useMobile from "customHooks/useMobile";
import useTranslation from "next-translate/useTranslation";
import { Dropdown } from "react-bootstrap";
import styled from "styled-components";
type Props = {
  item: any;
  index: number;
  typesConsts: any;
  curr: any;
  onEdit: (index: number) => void;
  onDelete: (index: number) => void;
};
const ZakatItemCard = ({
  item,
  index,
  typesConsts,
  curr,
  onEdit,
  onDelete,
}: Props) => {
  const consts = typesConsts[item.type];
  const { t } = useTranslation("common");
  const matches = useMobile("md");
  const {formatNumbers}=useFormatNumbers()

  const ItemKeyVal = ({ k, val, unit }) => {
    return (
      <div className="d-flex mt-2">
        <p className="mb-0 fs-base  mile-3">{k}</p>
        {unit && unit !== "Stock" && (
          <p className="mb-0 fs-base text-primary mils-2 fw-bold">{unit}</p>
        )}
        <p className="mb-0 fs-base text-primary  mils-1  fw-semibold">{val}</p>
        {unit && unit === "Stock" && (
          <p className="mb-0 fs-base text-primary mils-2 fw-bold">
            {unit}
            {val > 1 ? "s" : ""}
          </p>
        )}
      </div>
    );
  };

  return (
    <SyledZakatItemCard
      className={`mx-0 mb-3 col-md-6 col-lg-4 col-xl-4 col-sm-12   ${
        !matches ? "px-3" : "px-0"
      }`}
    >
      <StyledInnerContainer
        className={`card card-category shadow py-lg-2 py-3 px-0 px-lg-3 flex-row align-items-center justify-content-between px-3`}
      >
        <div className="v-centered">
          <div className="ms-2">
            <h3 className="card-title h3 adjust-text-1-col ellipsis-text-normal">
              {item.description !== ""
                ? item.description
                : t(item.type) + " " + (index + 1)}
            </h3>
            <ItemKeyVal
              unit={null}
              k={t("type")}
              val={
                item.type == "gold"
                  ? t(consts.title) + " " + item.karat
                  : t(consts.title)
              }
            />
            {consts.hasWeight && (
              <ItemKeyVal
                k={t(consts.amount_label)}
                val={t(item.amount)}
                unit={t("gram")}
              />
            )}
            {item.type == "stock" && (
              <ItemKeyVal
                k={t(consts.amount_label)}
                val={t(item.amount)}
                unit={t("stock")}
              />
            )}
            <ItemKeyVal
              k={t("amount")}
              val={formatNumbers(Number(item.amount * item.price))}
              unit={""}
            />
          </div>
        </div>
        <Dropdown className="btn px-0 mx-2 mx-md-0 hide-dropdown-arrow">
          <Dropdown.Toggle variant="none" className="p-0 " id="dropdown-basic">
            <i className={`fe-more-${"vertical"} font-size-xxl`}></i>
          </Dropdown.Toggle>
          <Dropdown.Menu as="ul">
            <Dropdown.Item
              as="li"
              onClick={() => {
                onEdit(index);
              }}
            >
              <i className="fe-edit"></i>{" "}
              <span className="mx-1">{t("edit")}</span>
            </Dropdown.Item>
            <Dropdown.Divider as="li" />
            <Dropdown.Item as="li" onClick={() => onDelete(index)}>
              <i className="fe-trash"></i>{" "}
              <span className="mx-1">{t("delete")}</span>
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </StyledInnerContainer>
    </SyledZakatItemCard>
  );
};

export default ZakatItemCard;
//no changing color on hover
const SyledZakatItemCard = styled.li`
  @media (max-width: 767px) {
    margin-bottom: 0 !important;
    min-height: 0 !important;
    .card {
      border: none !important;
      box-shadow: none !important;
      border-bottom: 1px solid var(--light-gray) !important;
      border-radius: 0 !important;
    }
    .card.card-hover:hover,
    .shadow-hover:hover,
    .card.card-active {
      border-color: var(--light-gray) !important;
      box-shadow: none !important;
      border-bottom: 1px solid var(--light-gray) !important;
    }
  }
`;
const StyledInnerContainer = styled.div`
  min-height: 148px;
  @media (max-width: 767px) {
    min-height: 0 !important;
  }
`;
